import React, { useEffect, useState } from "react";
import { CommonListType, useCommonListWrap } from "../../../hooks/useCommonList/useCommonListWrap";
import Location from "../../../../models/Location";
import {
    getDetailDestinations,
    getListDestinations,
    getRecommendLocation,
    getTopDestinations,
    offlineGetDetailDestination,
} from "../../../../services/LocationService";
import { withSsrRawDataMulti } from "../../../controls/common/StaticContextWrap";
import useStaticContext from "../../../hooks/useStaticContext";
import { EmailKeyword, getEmailKeywork } from "../../../../services/EmailSerivce";

export default function useEmailKeywork() {
    const [keywork, setKeywork] = useState<EmailKeyword[]>();
    const loadEmailKeywork = async () => {
        try {
            let prods = await getEmailKeywork();
            setKeywork(prods.data);
        } catch (error) {
            console.error(error);
        }
    };
    const reload = () => {
        loadEmailKeywork();
    };
    useEffect(() => {
            reload();
    }, []);
    return {
        keywork,
        reload,
    };
}
